import { render } from "./CardMain.vue?vue&type=template&id=65c02894&scoped=true"
import script from "./CardMain.vue?vue&type=script&lang=js"
export * from "./CardMain.vue?vue&type=script&lang=js"

import "./CardMain.vue?vue&type=style&index=0&id=65c02894&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c02894"]])

export default __exports__